import { Injectable } from '@angular/core';
import * as io from 'socket.io-client';
import { GatewayService } from 'src/app/gateway.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  socket: any;
  agente_id = null;
  public usuarioEmisor = null;

  // Conexión separada al namespace /locks (resource-lock)
  private locksSocket: any = null;

  constructor(
    private gateway: GatewayService,
    private localsave: LocalSaveService,) {
    // Defer init: si no hay sesión todavía (ej. estamos en /login), no crear socket
    // para no crashear la app. Se inicializa post-login vía initIfNeeded().
    this.initIfNeeded();
  }

  /**
   * Inicializa el socket del namespace default (alarmas) si todavía no fue creado y
   * hay un `usuarioPGV` válido en localStorage. Idempotente.
   * Llamar desde login (vía ResourceLockService.connect) o desde cualquier lugar
   * post-login que necesite garantizar el socket.
   */
  initIfNeeded(): void {
    if (this.socket) return;
    let user: any = null;
    try { user = this.localsave.get('usuarioPGV'); } catch (e) { user = null; }
    if (!user || !user.idagente) return;

    this.agente_id = user.idagente;
    this.usuarioEmisor = `agente_${this.agente_id}`;
    this.socket = io(this.gateway.globalip, {
      transports: ['websocket']
    });

    this.socket.on("connect", () => {
      this.socket.emit("register", `${this.usuarioEmisor}`);
    });
  }

  onNuevaAlarma(callback) {
    this.initIfNeeded();
    if (!this.socket) return;
    this.socket.on("alarma-pendiente", callback);
  }

  onAlarmaTomada(callback) {
    this.initIfNeeded();
    if (!this.socket) return;
    this.socket.on("alarma-tomada", callback);
  }

  tomarAlarma(data) {
    this.initIfNeeded();
    if (!this.socket) return;
    this.socket.emit("tomar-alarma", data);
  }

  onReasignacionAusencia(callback) {
    this.socket.on("reasignacion-ausencia", callback);
  }

  onCitaSinCoordenadasNueva(callback) {
    if (!this.socket) return;
    this.socket.on("cita-sin-coordenadas:nueva", callback);
  }

  onCitaSinCoordenadasResuelta(callback) {
    if (!this.socket) return;
    this.socket.on("cita-sin-coordenadas:resuelta", callback);
  }

  enviarRespuesta(usuarioReceptor: any, data: any) {
    this.socket.emit("server-to-user", {
      user_id: usuarioReceptor,
      payload: {
        from: this.usuarioEmisor,
        data: data
      }
    });
  }

  // ============================================================
  // Resource Lock — namespace /locks (segregado del default)
  // ============================================================

  /**
   * Inicializa la conexión al namespace /locks.
   * Llamar una vez después del login (ResourceLockService.connect).
   * Idempotente: si ya está conectado, devuelve la instancia existente.
   */
  initLocks(token: string, idagente: number): any {
    if (this.locksSocket) return this.locksSocket;
    this.locksSocket = io(`${this.gateway.globalip}/locks`, {
      query: { token: token, idagente: idagente },
      transports: ['websocket', 'polling']
    });
    return this.locksSocket;
  }

  getLocksSocket(): any {
    return this.locksSocket;
  }

  disconnectLocks(): void {
    if (this.locksSocket) {
      try { this.locksSocket.disconnect(); } catch (e) { /* ignorar */ }
      this.locksSocket = null;
    }
  }
}
